// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"layout-module--back-btn--21VY-","header":"layout-module--header--1agRL","horizCenter":"layout-module--horizCenter--3P-my"};